<template>
  <div>
    <v-bottom-nav
      fixed
      class="app-nav"
    >
    <v-container fluid class="pa-0">
        <v-layout row wrap>
     <!-- <v-btn small to="/activities">
        <i class="fas fa-home fa-lg" />
      </v-btn>-->
      <v-flex xs3 sm3>
            <v-btn to="/activities" flat icon>
              <i class="fas fa-home fa-lg" />
            </v-btn>
          </v-flex>
                <v-flex xs3 sm3 >
            <v-btn to="/leaderboard" flat icon>
              <i class="fas fa-chart-bar fa-lg" />
            </v-btn>
          </v-flex>
                <v-flex xs2 sm2>
            <v-btn to="/search" flat icon>
              <i class="fas fa-search fa-lg" />
            </v-btn>
          </v-flex>
                <v-flex xs2 sm2>
            <v-btn flat icon @click="redirectToProfile">
              <i class="far fa-user fa-lg" />
            </v-btn>
          </v-flex>
                <v-flex xs2 sm2 v-if="this.getUserById.user_team">
            <v-btn  @click="redirectToTeam" flat icon>
              <i class="fas fa-users fa-lg" />
            </v-btn>
          </v-flex>
     <!-- <v-btn
      small
        color="teal"
        to="/leaderboard"
        class="pr-4"
      >
        <i class="fas fa-chart-bar fa-lg" />
      </v-btn>
      <v-btn
      small
        to="/search"
        class="pl-4"
      >
        <i class="fas fa-search fa-lg" />
      </v-btn>
      <v-btn small @click="redirectToProfile">
        <i class="far fa-user fa-lg" />
      </v-btn>
      <v-btn small :to="{ name: 'team', params: { id: this.user.user_team[0].id }}">
        <i class="fas fa-users fa-lg" />
      </v-btn>-->
             </v-layout>
      </v-container>
    </v-bottom-nav>

    <div class="activity-tracker">
      <v-btn v-if="this.getTopActivity"
        fab
        color="red darken-3"
        class="activity-tracker_button white--text"
        :to="{ name: 'activity', params: { id: this.getTopActivity.id }}"
      >
        <i class="fas fa-plus" />
      </v-btn>
    </div>
  </div>
</template>

<script>
 // import { USER_REQUEST } from "../store/actions/user";
  import { mapGetters } from "vuex";
  export default {
    name: "BottomNavigation",
    methods: {
      redirectToProfile: function(){
        const user_id = localStorage.getItem('user_id');
        this.$store.dispatch('user/getUser', user_id);
        this.$router.push(`/user/${user_id}`);
      },
      redirectToTeam: function(){
        const user = this.getUserById.user_team[0];
        if (user){
          this.$store.dispatch('team/loadTeam', user.id);
          this.$router.push(`/team/${user.id}`);
        }
      }
    },
    computed: {
      user_id: function(){
          return localStorage.getItem('user_id');
      },
          ...mapGetters(
    'user', ['user', 'getCurrentUser', 'getUserById'],
    ),
              ...mapGetters(
    'activity', ['getTopActivity'],
    ),
    },

  mounted() {
    // wtf
   this.$store.dispatch('activity/activitiesRequest');
   this.$store.dispatch('user/getUserById', this.user_id);
       }
  }
</script>

<style scoped>
  .app-nav {
    bottom: 60px;
  }

  .activity-tracker {
    position: fixed;
    bottom: 25px;
    left: calc(50% - 32px);
    z-index: 5;
    /* background-color: #fff; */
    /* border: 5px solid rgba(255, 255, 255, 250); */
    border-radius: 100%;
    padding: 0;
  }

  .activity-tracker_button {

  }
</style>
